import { IconError404 } from "@tabler/icons-react";
import { useTranslation } from "react-i18next";
import { isRouteErrorResponse, useNavigate, useRouteError } from "react-router-dom";

import { ErrorDisplay } from "#app/monitoring/ErrorDisplay";
import { ROUTES } from "#shared/routes";
import { Center } from "#shared/view/components/Center";
import { Stack } from "#shared/view/components/Stack";
import { Button } from "#shared/view/designSystem/Button";

export function ErrorPage() {
  const { t } = useTranslation();
  const routeError = useRouteError();
  const navigate = useNavigate();

  const redirectToHome = () => {
    navigate(ROUTES.root);
  };

  if (isRouteErrorResponse(routeError) && routeError.status === 404) {
    return (
      <Center h="100vh" w="100vw">
        <Stack justify="center" align="center">
          <IconError404 />
          <p>{t("common.nothingHere")}</p>
          <Button variant="outline" onClick={redirectToHome}>
            {t("common.backToHome")}
          </Button>
        </Stack>
      </Center>
    );
  }

  return (
    <ErrorDisplay
      error={routeError}
      resetError={redirectToHome}
      resetErrorTitle={t("common.backToHome")}
    />
  );
}
